import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import { RaysLoadingStatus } from '@visualizer/types';
import { AlertCircle } from '@untitledui-pro/icons/line';
import CustomTooltip from '../../generic/CustomTooltip';

interface LoadingProps {
    status: RaysLoadingStatus;
    errorMessage?: string;
    children?: React.ReactNode;
}

const Loading: React.FC<LoadingProps> = ({ status, errorMessage, children }) => {
    switch (status) {
        case RaysLoadingStatus.NotLoaded:
            return '';
        case RaysLoadingStatus.Initializing:
            return 'Preparing...';
        case RaysLoadingStatus.Loading:
            return <CircularProgress size={100} />;
        case RaysLoadingStatus.Error:
            return (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                    <CustomTooltip side="left" title={errorMessage || 'An error occurred'}>
                        <AlertCircle color="error" className="icon-size-medium" />
                    </CustomTooltip>
                    <Typography variant="caption" color="error.main">
                        {errorMessage || 'An error occurred'}
                    </Typography>
                </Box>
            );
        case RaysLoadingStatus.Loaded:
            return <>{children}</>;
        default:
            throw new Error(`Unknown status: ${status}`);
    }
};

export default Loading;
